import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  savedRoutes: { [routeName: string]: Map<string, DetachedRouteHandle | null> } = {};

  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === current.routeConfig;
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return route.data.reuse && !!this.savedRoutes[this.getResolvedUrl(route)]?.has(this.getResolvedUrl(route));
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const url = this.getResolvedUrl(route);
    if (!route.routeConfig || !this.savedRoutes[url].get(url)) {
      return null;
    }

    return this.savedRoutes[url].get(url);
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.data.reuse;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (route.data.reuse) {
      const pathUrl = this.getResolvedUrl(route);

      if (this.savedRoutes[pathUrl] && this.savedRoutes[pathUrl].has(pathUrl)) {
        // match the route and url
        this.savedRoutes[pathUrl].set(pathUrl, handle);
      }
      else if (this.savedRoutes[pathUrl]) {
        // match route, but new url, destroy old comp & save new one
        this.destroyOldComponent(pathUrl);
        this.savedRoutes[pathUrl].clear();
        this.savedRoutes[pathUrl].set(pathUrl, handle);
      }
      else {
        // new route
        this.savedRoutes[pathUrl] = new Map<string, DetachedRouteHandle>();
        this.savedRoutes[pathUrl].set(pathUrl, handle);
      }
    }
  }

  getPath(route: ActivatedRouteSnapshot): string {
    return route.routeConfig ? route.routeConfig.path || '' : '';
  }

  getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
  }

  public destroyOldComponent(route: string): void {
    const handle = this.savedRoutes[route].values().next().value;

    if (handle) {
      (handle as any).componentRef.destroy();
    }
  }
}
